import { NavLink } from "react-router-dom";
import './navbar.css';

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg sticky-top custom-navbar" id="navbar">
      <div className="container py-2">
        <NavLink to="/" className="navbar-brand">
          <img src="/logo.png" alt="Logo Villa Capetinga" className="me-3 logo-img" />
          <span className="brand-text">Villa Capetinga</span>
        </NavLink>

        <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-items">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbar-items">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 gap-3">
            <li className="nav-item">
              <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/sobre" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
                Sobre
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contatos" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
                Contatos
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;